import { createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/loginlogo.png'
import _imports_1 from '@/assets/image/loginlogo2.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-07db1e9e")

_pushScopeId("data-v-07db1e9e")
const _hoisted_1 = { class: "bg-class" }
const _hoisted_2 = { class: "margin-0-auto width1090px" }
const _hoisted_3 = { class: "login-bg display-inline-block vertical-align-bottom" }
const _hoisted_4 = { class: "width400px display-inline-block bg-content" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_6 = {
  id: "form",
  class: "margin-top48px"
}
const _hoisted_7 = { class: "input-content" }
const _hoisted_8 = { class: "input-content" }
const _hoisted_9 = {
  key: 1,
  class: "btn btn-not-allowed"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  class: "position-relative top50px",
  src: _imports_1
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_jump_page = _resolveComponent("jump-page")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("p", null, _toDisplayString(_ctx.$wordList.LoginLogin), 1),
          _createVNode("form", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _withDirectives(_createVNode("input", {
                class: "margin-top18px",
                type: "text",
                onKeypress: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getLogin && _ctx.getLogin(...args))),
                placeholder: _ctx.$wordList.LoginUser,
                name: "username",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.loginParams.Account = $event)),
                autocomplete: "off"
              }, null, 40, ["placeholder"]), [
                [_vModelText, _ctx.loginParams.Account]
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _withDirectives(_createVNode("input", {
                class: "margin-top30px",
                type: "password",
                placeholder: _ctx.$wordList.LoginPassword,
                name: "password",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.loginParams.PassWd = $event)),
                onKeypress: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.getLogin && _ctx.getLogin(...args))),
                autocomplete: "off"
              }, null, 40, ["placeholder"]), [
                [_vModelText, _ctx.loginParams.PassWd]
              ])
            ]),
            (_ctx.disableTime === 0)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "btn",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
                }, _toDisplayString(_ctx.$wordList.LoginLogin), 1))
              : (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(_ctx.$wordList.LoginLogin+'('+_ctx.disableTime+')'), 1))
          ])
        ]),
        _hoisted_10
      ])
    ]),
    (_ctx.isShowJumpPage)
      ? (_openBlock(), _createBlock(_component_jump_page, {
          key: 0,
          jumpUrl: _ctx.jumpUrl,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowJumpPage=false))
        }, null, 8, ["jumpUrl"]))
      : _createCommentVNode("", true)
  ]))
})